export async function readJsonResponse(response) {
  if (response.ok) {
    return response.json();
  }

  let payload = {};
  try {
    payload = await response.json();
  } catch (_error) {
    // The API may be temporarily unavailable before returning JSON.
  }
  throw new Error(payload.message || requestFailureMessage(response.status));
}

function requestFailureMessage(status) {
  if (status === 401 || status === 403) {
    return "Your session is not authorized for this action.";
  }
  if (status === 404) {
    return "The requested market data was not found.";
  }
  if (status === 409) {
    return "The portfolio changed in another session. Refresh and try again.";
  }
  if (status === 429) {
    return "The service is busy. Try again shortly.";
  }
  if (status >= 500) {
    return "Market data is temporarily unavailable. Try again shortly.";
  }
  return "The request could not be completed. Check the entered values.";
}
